import { useFirestoreAllArrayContains } from '../../firebase/useFirestore';
import { client } from '../../hooks/Client';
import PageHeader from '../../components/layout/PageHeader';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import Tooltip from '../../components/common/Tooltip';
import { useState, useContext } from 'react';
import DeleteModal from "../../components/common/DeleteModal";
import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined'
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import LaunchOutlinedIcon from '@mui/icons-material/LaunchOutlined';
import { useHistory } from "react-router-dom";
import NewProjectModal from '../../components/portfolio/NewProjectModal';
import { v4 as uuid } from 'uuid';
import firebase from '../../firebase/compat';
import { Auth } from '../../StateManagment/Auth'
import SyncCounter from '../../components/portfolio/SyncCounter';
import Table from '../../components/common/table/Table.jsx';
import TableCell from '../../components/common/table/TableCell.jsx';
import ReadOnlyGuard from '../../components/common/ReadOnlyGuard';
import SharedResearchSelect from '../../components/portfolio/SharedResearchSelect';

const Projects = () => {
    // Context
    const [auth] = useContext(Auth)

    // State
    const [loading, setLoading] = useState(false)

    // State
    const [deleteModal, setDeleteModal] = useState(false)
    const [deleteDocid, setDeleteDocid] = useState('123')
    const [deleteName, setDeleteName] = useState('')
    const [projectId, setProjectId] = useState('')
    const [newProjectModal, setNewProjectModal] = useState(false)
    const [projectName, setProjectName] = useState('')
    const [logo, setLogo] = useState('')
    const [website, setWebsite] = useState('')
    // T29 — nieuwe modules-shape: { impactMeten, personas, housevisits, portfolio }
    const [modules, setModules] = useState({
        impactMeten: true,
        personas: false,
        housevisits: false,
        portfolio: false,
    })
    const [centralEmail, setCentralEmail] = useState('')
    const [partnerSlug, setPartnerSlug] = useState(null)
    const [networkCompagnyID, setNetworkCompagnyID] = useState(null)
    // Default: deeplink-mode. Demo-toggle creëert het project meteen i.p.v.
    // de signup-flow uit te delen.
    const [demoMode, setDemoMode] = useState(false)

    // Hooks
    const history = useHistory()
    const host = window.location.hostname

    // Firestore
    const projects = useFirestoreAllArrayContains('CompagnyMeta', 'Parent', client)

    // Delete modal 
    const deleteModalHandler = (e) => {
        const docid = e.currentTarget.dataset.docid
        const deleteName = e.currentTarget.dataset.deletename
        const id = e.currentTarget.dataset.id

        setDeleteDocid(docid)
        setDeleteName(deleteName)
        setProjectId(id)
        setDeleteModal(!deleteModal)
    }

    // Add project (T29 + T30)
    const addProject = async () => {

        setLoading(true)

        const id = uuid()

        // T30 — demo-mode sub-project: alle data is al door de admin
        // ingevuld, dus onboarding is per definitie klaar. Eerste login van
        // de sub-project owner gaat direct naar het dashboard.
        const onboardingStatus = {
            lastStep: 7,
            completed: true,
        }

        const createProjectAccount = firebase.functions().httpsCallable('createProjectAccount')

        const projectData = {
            compagny: projectName,
            logo: logo,
            trialType: 'compleet',
            ImpactManager: 'Deccos',
            Parent: client,
            Subscription: 'paid',
            CompagnyId: id,
            Auth: auth.Docid,
            website: website,
            onboarding: false,
            subscriptionType: 'paid',
            // T29 — nieuwe shape (createProjectAccount accepteert deze)
            modules,
            centralEmail,
            partner: partnerSlug,
            onboardingStatus,
            email: centralEmail,    // back-compat: oude `email` veld
        }

        // T26b — netwerk meegeven via networkCompagnyIDs[] zodat sub-project
        // direct in dat netwerk's Parent-array komt
        if (networkCompagnyID) {
            projectData.networkCompagnyIDs = [networkCompagnyID]
        }

        try {
            await createProjectAccount({ data: projectData })
        } catch (err) {
            console.error('addProject createProjectAccount error', err)
            setLoading(false)
            alert(`Project aanmaken is mislukt: ${err.message || 'onbekende fout'}`)
            return
        }

        setLoading(false)

        // Close + reset
        setNewProjectModal(false)
        setProjectName('')
        setLogo('')
        setWebsite('')
        setCentralEmail('')
        setPartnerSlug(null)
        setNetworkCompagnyID(null)
        setDemoMode(false)
        setModules({
            impactMeten: true,
            personas: false,
            housevisits: false,
            portfolio: false,
        })
    }

    // Delete project
    const deleteProject = async () => {

        setLoading(true)

        // Delete project from portfolio cloud function
        const deletePortfolioProject = firebase.functions().httpsCallable('deletePortfolioProject');

        // Data for deleting project
        const data = {
            docid: deleteDocid,
            portfolioId: client,
        }

        // Delete project from portfolio
        await deletePortfolioProject({ data: data })
 
    }

  return (
    <div className="main">
        <div className="main-container">
            <PageHeader 
                heading={'Projecten'}
                description={`Hier vind je een overzicht van alle projecten uit je portfolio`}
                AI={false}
            />
    <div className="page-content-container">
        <ReadOnlyGuard edit="portfolio.edit">
        {(canEdit) => (
        <>
        {/* Waarmee meet dit programma zijn leden? Staat hier omdat dit de
            pagina is waar de koepel zijn deelnemers ziet. */}
        <SharedResearchSelect />
        <Table
            columns={[
                { key: 'name', label: 'NAAM' },
                { key: 'syncs', label: 'KOPPELINGEN', searchable: false },
                { key: 'details', label: 'DETAILS', searchable: false },
                { key: 'environment', label: 'PROJECT OMGEVING', searchable: false },
                { key: 'delete', label: 'VERWIJDEREN', searchable: false },
            ]}
            items={projects || []}
            getItemKey={(project) => project.CompagnyID || project.ID}
            renderRow={(project) => (
                <>
                    <TableCell>
                        <p>{project.CommunityName}</p>
                    </TableCell>
                    <TableCell>
                        <AddCircleOutlineOutlinedIcon
                            className='table-delete-icon'
                            onClick={() => history.push(`/${client}/synchronisationsportfolio/${project.CompagnyID}`)}
                        />
                        <div className='portfolio-projects-sync-counter-container' id='indicator-effect-icons-container'>
                            <p><SyncCounter id={project.CompagnyID} /></p>
                        </div>
                    </TableCell>
                    <TableCell>
                        <SearchOutlinedIcon onClick={() => history.push(`/${client}/portfolioprojectdetails/${project.CompagnyID}`)} />
                    </TableCell>
                    <TableCell>
                        {host === 'localhost' ?
                        <a href={`http://${host}:3000/${project.CompagnyID}/home`} target="_blank" rel="noreferrer"><LaunchOutlinedIcon/></a>
                        :
                        <a href={`https://${host}/${project.CompagnyID}/home`} target="_blank" rel="noreferrer"><LaunchOutlinedIcon/></a>
                        }
                    </TableCell>
                    <TableCell>
                        {canEdit && (
                            <Tooltip content='Project verwijderen' top='-60px'>
                                <DeleteOutlinedIcon className='table-delete-icon' data-id={project.CompagnyID} data-docid={project.docid} data-deletename={project.CommunityName} onClick={deleteModalHandler} />
                            </Tooltip>
                        )}
                    </TableCell>
                </>
            )}
            searchAccessor={(project) => project?.CommunityName || ''}
            searchPlaceholder="Zoeken op naam"
            emptyMessage="Geen projecten gevonden."
            addRow={canEdit ? {
                toolTipContent: 'Project toevoegen',
                onClick: () => setNewProjectModal(true),
            } : undefined}
        />
        </>
        )}
        </ReadOnlyGuard>
            </div>
        </div>
        <DeleteModal
        deleteModal={deleteModal}
        setDeleteModal={setDeleteModal}
        setDeleteDocid={setDeleteDocid}
        deleteItem={deleteProject}
        deleteName={deleteProject}
        />
        <NewProjectModal
        newProjectModal={newProjectModal}
        setNewProjectModal={setNewProjectModal}
        setProjectName={setProjectName}
        setLogo={setLogo}
        logo={logo}
        setWebsite={setWebsite}
        addProject={addProject}
        loading={loading}
        modules={modules}
        setModules={setModules}
        centralEmail={centralEmail}
        setCentralEmail={setCentralEmail}
        partnerSlug={partnerSlug}
        setPartnerSlug={setPartnerSlug}
        networkCompagnyID={networkCompagnyID}
        setNetworkCompagnyID={setNetworkCompagnyID}
        demoMode={demoMode}
        setDemoMode={setDemoMode}
        parentCompagnyId={client}
        />
    </div>
  )
}

export default Projects
